<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            @if (phone) {
                <div>Ověření telefonu</div>
            }
            @if (email) {
                <div>Ověření e-mailu</div>
            }
        </div>
    </div>

    <form [formGroup]="activationForm" [attr.data-testid]="'verify-dialog'">
        <div class="hypo-dialog-content flex flex-col gap-4">
            @if (phone) {
                <p class="mb-2">
                    Pro přihlášení opište šestimístný kód, který jsme vám právě odeslali na telefon
                    <strong>{{ phone.phoneCountryCode }}&nbsp;{{ phone.phoneNumber }}</strong
                    >.
                </p>
                <p class="mb-2">Odesílatelem SMS je <strong>hypo</strong>.</p>
                @if (!isIphone) {
                    <p class="gray text-sm mb-2">
                        <span><b>Tip:</b> Máte telefon s Androidem a kód vám nedorazil? Najdete jej ve spamu.</span
                        >&nbsp;
                        <a (click)="displayAndroidProcess()">
                            {{ androidShowProcess ? 'Skrýt postup&nbsp;«' : 'Zobrazit postup&nbsp;»' }}
                        </a>
                    </p>
                }
                @if (androidShowProcess) {
                    <div class="gray text-sm mb-2">
                        <ol>
                            <li>Otevřete Google zprávy 💬.</li>
                            <li>
                                Klepněte na svoji <b>profilovou fotku</b> nebo ikonu ᐳ a pak na ikonu možností ⋮ ᐳ Více
                                a pak <b>Spam a zablokované konverzace</b>.
                            </li>
                            <li>Vyberte kontakt <b>hypo</b> ze seznamu.</li>
                            <li>Klepněte na <b>Odblokovat</b>.</li>
                            <li>Zprávy se zobrazí na hlavní obrazovce.</li>
                        </ol>
                    </div>
                }
            }

            @if (email) {
                <p [hidden]="!isDesktop">
                    Abychom si ověřili, že jste to skutečně Vy, <br />
                    opište, prosím, kód zaslaný e-mailovou zprávou.
                </p>
                <p>
                    Právě Vám byla odeslána ověřovací zpráva<br />na email&nbsp;<strong>{{ email }}</strong>
                </p>
            }

            @if (!verifiedState) {
                <p class="hnm-warning-text">Nesprávný ověřovací kód.</p>
            }

            <label class="input-label">Prosím, opište číselný kód do polí níže.</label>
            <div class="verification-code-row">
                <ng-container formArrayName="activationCode">
                    @for (
                        activationCodeInput of activationCodeForm.controls;
                        track activationCodeInput;
                        let i = $index
                    ) {
                        <mat-form-field floatLabel="always">
                            <input
                                class="code-inputs"
                                #activationInput
                                type="number"
                                max="9"
                                id="activation_code_{{ i }}"
                                name="activation_code_{{ i }}"
                                [formControlName]="i"
                                (paste)="codePasteEvent($event)"
                                (keyup)="codeKeyEvent($event, i)"
                                autocomplete="one-time-code"
                                matInput />
                        </mat-form-field>
                    }
                </ng-container>
            </div>
        </div>

        <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-between">
            <button
                class="btn btn-sm primary-transparent"
                id="cancel-phone-verification"
                type="button"
                mat-button
                color="warn"
                (click)="closeDialog()"
                [attr.data-testid]="'verify-dialog-button-cancel'">
                Zrušit
            </button>
            <button
                id="submit-phone-verification"
                class="btn btn-sm orange"
                type="button"
                (click)="submitDialog()"
                mat-raised-button="mat-raised-button"
                color="accent"
                [attr.data-testid]="'verify-dialog-button-ok'"
                [disabled]="!verifyApprove">
                OK
            </button>
        </div>
    </form>
</mat-dialog-content>
